{
  "titles": {
    "appointmentDetailsHaveChanged": "予約の詳細が変更されました",
    "appointmentScheduled": "予約が確定しました",
    "appointmentConfirmed": "予約が承認されました",
    "appointmentRequested": "予約がリクエストされました",
    "missedAppointment": "予約に不着",
    "recurringAppointmentSeriesCreated": "定期予約シリーズが作成されました",
    "truckArrivedAtFacility": "トラックが施設に到着しました",
    "appointmentIsInProgressAtFacility": "施設で予約の作業中です",
    "appointmentRescheduled": "予約の日時が変更されました",
    "appointmentCompleted": "予約が完了しました",
    "appointmentCancelled": "予約がキャンセルされました",
    "appointmentTagged": "予約にタグが付けられました",
    "assetReadyForPickup": "アセットの引き取り準備が完了しました"
  },
  "subjects": {
    "appointmentDetailsHaveChanged": "予約の詳細が変更されました",
    "appointmentScheduled": "{orgName} - {warehouseName} の予約が確定しました",
    "appointmentConfirmed": "{orgName} - {warehouseName} の予約が承認されました",
    "appointmentRequested": "{orgName} - {warehouseName} の予約がリクエストされました",
    "missedAppointment": "{orgName} - {warehouseName} の予約に不着",
    "recurringAppointmentSeriesCreated": "定期予約シリーズが作成されました",
    "truckArrivedAtFacility": "トラックが {orgName} - {warehouseName} に到着しました",
    "appointmentIsInProgressAtFacility": "{orgName} - {warehouseName} で予約の作業中です",
    "appointmentRescheduled": "{orgName} - {warehouseName} の予約の日時が変更されました",
    "appointmentCompleted": "{orgName} - {warehouseName} の予約が完了しました",
    "appointmentCancelled": "{orgName} - {warehouseName} の予約がキャンセルされました",
    "appointmentTagged": "予約にタグ「{tagName}」が付けられました - {warehouseName}",
    "assetReadyForPickup": "引き取り準備完了 - コンテナ {containerNumber}"
  },
  "subTitles": {
    "appointmentDetailsHaveChanged": "場所、日付、時刻、および以下のすべての詳細をご確認ください。",
    "appointmentScheduled": "場所、日付、時刻、および以下のすべての詳細をご確認ください。",
    "appointmentConfirmed": "場所、日付、時刻、および以下のすべての詳細をご確認ください。",
    "appointmentRequested": "倉庫の確認をお待ちください。",
    "missedAppointment": "運送会社は予約時刻に到着しませんでした。",
    "recurringAppointmentSeriesCreated": "以下の定期予約の詳細をご確認ください。",
    "truckArrivedAtFacility": "以下のステータスと予約の詳細をご確認ください。",
    "appointmentIsInProgressAtFacility": "以下のステータスと予約の詳細をご確認ください。",
    "appointmentRescheduled": "以下のステータスと予約の詳細をご確認ください。",
    "appointmentCompleted": "以下のステータスと予約の詳細をご確認ください。",
    "appointmentCancelled": "すべての詳細とキャンセルの理由をご確認ください。",
    "appointmentTagged": "以下のタグ名と情報をご確認ください。",
    "assetReadyForPickup": "施設にあるアセットの引き取り準備が完了しました。"
  },
  "anchorLabels": {
    "appointmentDetailsHaveChanged": "予約を表示",
    "appointmentScheduled": "予約を表示",
    "appointmentConfirmed": "予約を表示",
    "appointmentRequested": "予約を表示",
    "missedAppointment": "予約を表示",
    "recurringAppointmentSeriesCreated": "元の予約を表示",
    "truckArrivedAtFacility": "予約を表示",
    "appointmentIsInProgressAtFacility": "予約を表示",
    "appointmentRescheduled": "予約を表示",
    "appointmentCompleted": "予約を表示",
    "appointmentCancelled": "予約を表示",
    "appointmentTagged": "予約を表示",
    "assetReadyForPickup": "予約を表示"
  },
  "descriptions": {
    "appointmentTagged": "予約タグの設定を使って、タグごとに個別に有効化してください"
  },
  "contextLabels": {
    "assetReadyForPickup": {
      "schedulingAnchorLabel": "引き取りを予約",
      "idLabel": "確認番号",
      "ownedByLabel": "所有者：",
      "pickupScheduledForLabel": "引き取り予定日時：",
      "noPickupScheduledLabel": "引き取りの予約はありません",
      "storeLabel": "店舗",
      "openInGoogleMapsLabel": "Google マップで開く",
      "appointmentDetailsLabel": "予約の詳細",
      "loadTypeLabel": "荷物の種類",
      "warehouseInstructionsLabel": "倉庫からの案内事項",
      "amenitiesLabel": "利用可能な設備",
      "ppeRequirementsLabel": "保護具（PPE）とその他の要件",
      "dockDoorLabel": "ドック扉",
      "dockInstructionsLabel": "ドックの案内事項",
      "carrierContactLabel": "運送会社の担当者"
    }
  }
}
